import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITaskService = ( createDecorator('taskService'));
export { ITaskService };
